import { $ } from "@/common/Axios";

export default {
  /**
   * 需求管理
   */
  requirement_leaderUpdate: {
    /*
     * 编辑（项目负责人）
     * id id (integer query required)
     * step 阶段 (string query required)
     * urgencyLevel 紧急程度 (string query )
     * preStartTime 预计开发开始时间 (string query )
     * preOnlineTime 预计交付时间 (string query )
     * actualOnlineTime 实际上线时间 (string query )
     * docQiniuUrl 使用文档地址 (string query )
     * remark 项目负责人备注 (string query )
     */
    put: (p, c) => $.put("/api/bms/develop/requirement/leaderUpdate", p, c),
  },
  requirement_update: {
    /*
     * 编辑
     * id id (integer query )
     * name 需求名称 (string query required)
     * purpose 开发目的 (string query required)
     * description 具体开发内容 (string query required)
     * extraQiniuUrl 需求文档 (string query )
     * partnerDepartments 其他配合部门，多选逗号隔开 (string query )
     */
    post: (p, c) => $.post("/api/bms/develop/requirement/update", p, c),
  },
  requirement_save: {
    /*
     * 添加
     * department 需求部门 (string query required)
     * name 需求名称 (string query required)
     * purpose 开发目的 (string query required)
     * description 具体开发内容 (string query required)
     * extraQiniuUrl 需求文档 (string query )
     * partnerDepartments 其他配合部门，多选逗号隔开 (string query )
     */
    post: (p, c) => $.post("/api/bms/develop/requirement/save", p, c),
  },
  requirement_list: {
    /*
     * 列表(开发管理-需求管理)
     */
    get: (p, c) => $.get("/api/bms/develop/requirement/list", p, c),
  },
  requirement_listRequirementDepartment: {
    /*
     * 简单需求部门列表
     */
    get: (p, c) =>
      $.get("/api/bms/develop/requirement/listRequirementDepartment", p, c),
  },
  requirement_listPartnerDepartment: {
    /*
     * 配合部门列表
     */
    get: (p, c) =>
      $.get("/api/bms/develop/requirement/listPartnerDepartment", p, c),
  },
  requirement_listForApply: {
    /*
     * 列表(内部管理-需求开发)
     */
    get: (p, c) => $.get("/api/bms/develop/requirement/listForApply", p, c),
  },
  requirement_listApplyDepartment: {
    /*
     * 登录人可添加需求部门列表， 为空则无添加权限
     */
    get: (p, c) =>
      $.get("/api/bms/develop/requirement/listApplyDepartment", p, c),
  },
  requirement_export: {
    /*
     * 导出(开发管理-需求管理)
     */
    get: (p, c) => $.get("/api/bms/develop/requirement/export", p, c),
  },
  requirement_detail: {
    /*
     * 详情
     * id id (integer query )
     */
    get: (p, c) => $.get("/api/bms/develop/requirement/detail", p, c),
  },
  requirement_remove: {
    /*
     * 删除-撤回和拒绝状态下
     * id ID (integer query )
     */
    delete: (p, c) => $.delete("/api/bms/develop/requirement/remove", p, c),
  },

  /**
   * 本地文件保存时间配置
   */
  localFileConfig_removeLocalTempFiles: {
    /*
     * 临时-删除本地下载的一些文件
     * dir 目录 (string query )
     */
    put: (p, c) =>
      $.put("/api/bms/develop/localFileConfig/removeLocalTempFiles", p, c),
  },
  localFileConfig: {
    /*
     * 添加
     * config  ( query required)
     */
    post: (p, c) => $.post("/api/bms/develop/localFileConfig", p, c),
  },

  /**
   * 动态代码
   */
  dynamicCode_refreshCache: {
    /*
     * 刷新缓存
     */
    put: (p, c) => $.put("/api/bms/develop/dynamicCode/refreshCache", p, c),
  },
  dynamicCode: {
    /*
     * 添加
     * dynamicCode  ( query required)
     */
    post: (p, c) => $.post("/api/bms/develop/dynamicCode", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/bms/develop/dynamicCode", p, c),
  },
  dynamicCode_testEval: {
    /*
     * 测试执行代码
     * id id (integer query required)
     * params 参数 (string query required)
     */
    post: (p, c) => $.post("/api/bms/develop/dynamicCode/testEval", p, c),
  },
  dynamicCode_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/bms/develop/dynamicCode/list", p, c),
  },
  dynamicCode_details: {
    /*
     * 详情
     * id id (integer query required)
     */
    get: (p, c) => $.get("/api/bms/develop/dynamicCode/details", p, c),
  },

  /**
   * 数据修复
   */
  dataRepair_update: {
    /*
     * 编辑
     * id ID (integer query required)
     * title 标题,16个字以内 (string query required)
     * content 修复内容 (string query required)
     * attachmentUrl 附件 (string query )
     * dingDepartmentId 钉钉部门id (integer query required)
     */
    put: (p, c) => $.put("/api/bms/develop/dataRepair/update", p, c),
  },
  dataRepair_sync: {
    /*
     * 同步
     * id instanceId (string query required)
     */
    put: (p, c) => $.put("/api/bms/develop/dataRepair/sync", p, c),
  },
  dataRepair_save: {
    /*
     * 添加
     * title 标题,16个字以内 (string query required)
     * content 修复内容 (string query required)
     * attachmentUrl 附件 (string query )
     * dingDepartmentId 钉钉部门id (integer query required)
     */
    post: (p, c) => $.post("/api/bms/develop/dataRepair/save", p, c),
  },
  dataRepair_dispose: {
    /*
     * 处理修复
     * id id (integer query required)
     * operatorResult 修复结果,下拉 (string query required)
     * operatorRemark 修复备注 (string query required)
     * extraFileUrl 附件 (string query )
     */
    post: (p, c) => $.post("/api/bms/develop/dataRepair/dispose", p, c),
  },
  dataRepair_list: {
    /*
     * 列表-基础平台-开发管理
     */
    get: (p, c) => $.get("/api/bms/develop/dataRepair/list", p, c),
  },
  dataRepair_listForApply: {
    /*
     * 列表-基础平台-内部管理
     */
    get: (p, c) => $.get("/api/bms/develop/dataRepair/listForApply", p, c),
  },
  dataRepair_details: {
    /*
     * 详情
     * id ID (integer query required)
     */
    get: (p, c) => $.get("/api/bms/develop/dataRepair/details", p, c),
  },
  dataRepair_remove: {
    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/bms/develop/dataRepair/remove", p, c),
  },

  /**
   * 系统配置
   */
  config_setAllDataAdmin: {
    /*
     * 设置能查看所有数据管理员
     * path 请求路径 (string query required)
     * adminIds 管理员id列表 (array query required)
     */
    put: (p, c) => $.put("/api/bms/develop/config/setAllDataAdmin", p, c),
  },
  config_refreshCache: {
    /*
     * 刷新缓存
     */
    put: (p, c) => $.put("/api/bms/develop/config/refreshCache", p, c),
  },
  config: {
    /*
     * 添加
     * config  ( query required)
     */
    post: (p, c) => $.post("/api/bms/develop/config", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/bms/develop/config", p, c),
  },
  config_restore: {
    /*
     * 修复配置
     */
    post: (p, c) => $.post("/api/bms/develop/config/restore", p, c),
  },
  config_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/bms/develop/config/list", p, c),
  },
  config_listSelect: {
    /*
     * 选项列表
     * key 键 (string query )
     */
    get: (p, c) => $.get("/api/bms/develop/config/listSelect", p, c),
  },
  config_listByEducation: {
    /*
     * 列表-学历教育平台
     */
    get: (p, c) => $.get("/api/bms/develop/config/listByEducation", p, c),
  },
  config_listAllDataAdmin: {
    /*
     * 获取能查看所有数据管理员
     * path 请求路径 (string query required)
     */
    get: (p, c) => $.get("/api/bms/develop/config/listAllDataAdmin", p, c),
  },
  config_getConfigByKey: {
    /*
     * 获取字符串类型的值
     * key 键 (string query required)
     */
    get: (p, c) => $.get("/api/bms/develop/config/getConfigByKey", p, c),
  },
  config_getByKey: {
    /*
     * 根据key获取配置
     * key 键 (string query required)
     */
    get: (p, c) => $.get("/api/bms/develop/config/getByKey", p, c),
  },

  /**
   * 回调管理
   */
  callback_setHighScoreAdmins: {
    /*
     * 设置高分线索处理人
     * adminIds 处理人id列表 (array query required)
     */
    put: (p, c) => $.put("/api/bms/develop/callback/setHighScoreAdmins", p, c),
  },
  callback_setBlackPhone: {
    /*
     * 更新手机号黑名单
     * phones 手机号 (array query required)
     */
    put: (p, c) => $.put("/api/bms/develop/callback/setBlackPhone", p, c),
  },
  callback_handle: {
    /*
     * 处理
     * id id (integer query required)
     */
    put: (p, c) => $.put("/api/bms/develop/callback/handle", p, c),
  },
  callback_listType: {
    /*
     * 类型列表
     * tradeType 业务类型 (string query required)
     */
    get: (p, c) => $.get("/api/bms/develop/callback/listType", p, c),
  },
  callback_listPlatform: {
    /*
     * 平台列表
     * tradeType 业务类型 (string query required)
     */
    get: (p, c) => $.get("/api/bms/develop/callback/listPlatform", p, c),
  },
  callback_listForCustomer: {
    /*
     * 客服回调列表
     */
    get: (p, c) => $.get("/api/bms/develop/callback/listForCustomer", p, c),
  },
  callback_getHighScoreAdmins: {
    /*
     * 获取高分线索处理人
     */
    get: (p, c) => $.get("/api/bms/develop/callback/getHighScoreAdmins", p, c),
  },
  callback_getBlackPhone: {
    /*
     * 获取手机号黑名单
     */
    get: (p, c) => $.get("/api/bms/develop/callback/getBlackPhone", p, c),
  },

  /**
   * 需求部门配置
   */
  requirementConfig_save: {
    /*
     * 添加
     * id id (integer query )
     * department 部门名称 (string query required)
     * applyId 需求申请人 (integer query required)
     * auditId 需求审核人 (integer query required)
     * copyReceiverIds 抄送人ID列表,逗号隔开 (array query required)
     */
    post: (p, c) => $.post("/api/bms/develop/requirementConfig/save", p, c),
  },
  requirementConfig_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/bms/develop/requirementConfig/list", p, c),
  },
  requirementConfig_listCopyReceiver: {
    /*
     * 抄送人列表
     * id id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/bms/develop/requirementConfig/listCopyReceiver", p, c),
  },

  /**
   * 意见反馈
   */
  feedback: {
    /*
     * 添加
     * feedback  ( query required)
     */
    post: (p, c) => $.post("/api/bms/develop/feedback", p, c),
  },
  feedback_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/bms/develop/feedback/list", p, c),
  },
  feedback_listAppName: {
    /*
     * 应用名称列表
     */
    get: (p, c) => $.get("/api/bms/develop/feedback/listAppName", p, c),
  },

  /**
   * 数据查询配置
   */
  dataQuery: {
    /*
     * 添加或修改
     * dataQuery  ( query required)
     */
    post: (p, c) => $.post("/api/bms/develop/dataQuery", p, c),

    /*
     * 删除
     * name 名称 (string query required)
     */
    delete: (p, c) => $.delete("/api/bms/develop/dataQuery", p, c),
  },
  dataQuery_vocationalTeacherMonthPerformance: {
    /*
     * 获取职教班主任月业绩数据
     */
    get: (p, c) =>
      $.get(
        "/api/bms/develop/dataQuery/vocationalTeacherMonthPerformance",
        p,
        c
      ),
  },
  dataQuery_syncYunqueXiaohongshu: {
    /*
     * 从云雀同步小红书账号列表到系统配置
     */
    get: (p, c) =>
      $.get("/api/bms/develop/dataQuery/syncYunqueXiaohongshu", p, c),
  },
  dataQuery_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/bms/develop/dataQuery/list", p, c),
  },
  dataQuery_listGmvData: {
    /*
     * gmv数据列表
     * type 类型：业绩，催费 (string query required)
     * monthType 月份类型：当月、总计 (string query required)
     * month 月份:1,2...12 (string query required)
     * team 队伍 (string query )
     */
    get: (p, c) => $.get("/api/bms/develop/dataQuery/listGmvData", p, c),
  },
  dataQuery_getByName: {
    /*
     * 根据名称获取配置
     * name 名称 (string query required)
     */
    get: (p, c) => $.get("/api/bms/develop/dataQuery/getByName", p, c),
  },
  dataQuery_executeOne: {
    /*
     * 根据名称执行查询（返回单个对象），根据配置自动注入权限参数
     * name 名称 (string query required)
     * keyList 参数名列表 (array query )
     * valList 参数值列表 (array query )
     */
    get: (p, c) => $.get("/api/bms/develop/dataQuery/executeOne", p, c),
  },
  dataQuery_executeList: {
    /*
     * 根据名称执行查询（返回列表），根据配置自动注入权限参数
     * name 名称 (string query required)
     * keyList 参数名列表 (array query )
     * valList 参数值列表 (array query )
     * pageNum 页码 (integer query )
     * pageSize 每页条数，最大500 (integer query )
     */
    get: (p, c) => $.get("/api/bms/develop/dataQuery/executeList", p, c),
  },

  /**
   * CLI操作
   */
  cliOperation: {
    /*
     * 添加或修改操作
     * cliOperation  ( query required)
     */
    post: (p, c) => $.post("/api/bms/develop/cliOperation", p, c),

    /*
     * 删除操作
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/bms/develop/cliOperation", p, c),
  },
  cliOperation_status: {
    /*
     * 变更 Agent Tool 状态：PUBLISHED 发布 / DISABLED 禁用 / DEPRECATED 废弃
     * id 操作ID (integer query required)
     * status 目标状态 (string query required)
     */
    post: (p, c) => $.post("/api/bms/develop/cliOperation/status", p, c),
  },
  cliOperation_list: {
    /*
     * 根据管理员权限获取可用操作列表
     */
    get: (p, c) => $.get("/api/bms/develop/cliOperation/list", p, c),
  },
  cliOperation_listAll: {
    /*
     * 获取全部操作列表（管理后台用）
     */
    get: (p, c) => $.get("/api/bms/develop/cliOperation/listAll", p, c),
  },
  cliOperation_detail: {
    /*
     * 获取操作详情
     * id 操作ID (integer query required)
     */
    get: (p, c) => $.get("/api/bms/develop/cliOperation/detail", p, c),
  },

  /**
   * APP版本管理
   */
  appVersion: {
    /*
     * 添加
     * appVersion  ( query required)
     */
    post: (p, c) => $.post("/api/bms/develop/appVersion", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/bms/develop/appVersion", p, c),
  },
  appVersion_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/bms/develop/appVersion/list", p, c),
  },
  appVersion_getAppVersion: {
    /*
     * 获取Ａｐｐ版本
     * name App名字 (string query required)
     * deviceType 设备 (string query required)
     * channel 渠道 (string query )
     */
    get: (p, c) => $.get("/api/bms/develop/appVersion/getAppVersion", p, c),
  },

  /**
   * 数据库Schema查询
   */
  schema_tables: {
    /*
     * 获取表列表
     * database 数据库名 (string query required)
     */
    get: (p, c) => $.get("/api/bms/develop/schema/tables", p, c),
  },
  schema_indexes: {
    /*
     * 获取表索引
     * database 数据库名 (string query required)
     * table 表名 (string query required)
     */
    get: (p, c) => $.get("/api/bms/develop/schema/indexes", p, c),
  },
  schema_foreignKeys: {
    /*
     * 获取外键约束
     * database 数据库名 (string query required)
     * table 表名 (string query required)
     */
    get: (p, c) => $.get("/api/bms/develop/schema/foreignKeys", p, c),
  },
  schema_databases: {
    /*
     * 获取数据库列表
     */
    get: (p, c) => $.get("/api/bms/develop/schema/databases", p, c),
  },
  schema_createTable: {
    /*
     * 获取建表语句
     * database 数据库名 (string query required)
     * table 表名 (string query required)
     */
    get: (p, c) => $.get("/api/bms/develop/schema/createTable", p, c),
  },
  schema_columns: {
    /*
     * 获取表字段详情
     * database 数据库名 (string query required)
     * table 表名 (string query required)
     */
    get: (p, c) => $.get("/api/bms/develop/schema/columns", p, c),
  },

  /**
   * 回调聊天记录
   */
  callbackChatRecord_listAll: {
    /*
     * 根据线索ID获取所有客服聊天记录
     * clueId 线索ID (integer query required)
     */
    get: (p, c) => $.get("/api/bms/develop/callbackChatRecord/listAll", p, c),
  },
  callbackChatRecord_latest: {
    /*
     * 根据线索ID获取最近的客服聊天记录
     * clueId 线索ID (integer query required)
     */
    get: (p, c) => $.get("/api/bms/develop/callbackChatRecord/latest", p, c),
  },
};
